import { db, docsFromSnapshot, docFromSnapshot } from "../../firebase";
import _ from "lodash";

const state = {
  recurringInvoices: {},
  recurringInvoice: null
};

const getters = {
  recurringInvoices: state => _.values(state.recurringInvoices),
  recurringInvoicesCount: state => _.values(state.recurringInvoices).length | 0,
  recurringInvoice: state => state.recurringInvoice
};

const actions = {
  async fetchRecurringInvoices({ commit, getters }) {
    const snapshot = await db
      .collection("recurring-invoices")
      .where("tenantId", "==", getters.tenantId)
      .where("deleted", "==", false)
      .get();

    commit("setRecurringInvoices", docsFromSnapshot(snapshot));
  },
  async fetchRecurringInvoice({ commit }, id) {
    commit("resetRecurringInvoice");

    const snapshot = await db
      .collection("recurring-invoices")
      .doc(id)
      .get();

    const doc = docFromSnapshot(snapshot);
    if (doc) {
      commit("setRecurringInvoice", doc);
    }
  },
  async addRecurringInvoice({ commit, getters }, doc) {
    doc = {
      ...doc,
      tenantId: getters.tenantId,
      deleted: false
    };

    const snapshot = await db.collection("recurring-invoices").add(doc);
    const saved = {
      ...doc,
      _id: snapshot.id,
      id: snapshot.id
    };

    commit("setRecurringInvoice", saved);

    return { data: { id: snapshot.id } };
  },
  async terminateRecurringInvoice(context, recurringInvoice) {
    const id = recurringInvoice._id || recurringInvoice.id;
    if (!id) {
      throw new Error("Recurring invoice id is missing");
    }

    const updated = {
      ...recurringInvoice,
      _id: id,
      status: "CANCELLED"
    };

    await db
      .collection("recurring-invoices")
      .doc(id)
      .set(updated);

    context.commit("setRecurringInvoice", updated);
  }
};

const mutations = {
  setRecurringInvoices(state, docs) {
    state.recurringInvoices = docs;
  },
  setRecurringInvoice(state, recurringInvoice) {
    if (!recurringInvoice) {
      state.recurringInvoice = null;
      return;
    }
    const id = recurringInvoice._id || recurringInvoice.id;
    if (id) {
      const normalized = { ...recurringInvoice, _id: id, id };
      state.recurringInvoices[id] = normalized;
      state.recurringInvoice = normalized;
    } else {
      state.recurringInvoice = recurringInvoice;
    }
  },
  resetRecurringInvoice(state) {
    state.recurringInvoice = null;
  }
};

export default {
  state,
  actions,
  getters,
  mutations
};
